/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { Progress } from 'reactstrap';
import type { GenerationRunProgress } from '@g17eco/types/insights-synthesis';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';

interface InsightProgressBarProps {
  progress: GenerationRunProgress;
}

export const InsightProgressBar = ({ progress }: InsightProgressBarProps) => {
  const { total, approved, rejected, pruned, pending } = progress;

  const getPercentage = (value: number) => (total === 0 ? 0 : (value / total) * 100);

  const tooltipContent = (
    <div className='text-start'>
      <div><strong>Progress breakdown:</strong></div>
      <div className='d-flex justify-content-between gap-3'>
        <span>Approved:</span><span>{approved}</span>
      </div>
      <div className='d-flex justify-content-between gap-3'>
        <span>Pending approval:</span><span>{pending}</span>
      </div>
      <div className='d-flex justify-content-between gap-3'>
        <span>Rejected:</span><span>{rejected}</span>
      </div>
      <div className='d-flex justify-content-between gap-3'>
        <span>Pruned:</span><span>{pruned}</span>
      </div>
    </div>
  );

  return (
    <SimpleTooltip text={tooltipContent}>
      <div className='w-100' style={{ cursor: 'help' }}>
        <Progress multi style={{ height: '8px' }}>
          <Progress bar color='success' value={getPercentage(approved)} />
          <Progress bar color='warning' value={getPercentage(pending)} />
          <Progress bar color='danger' value={getPercentage(rejected)} />
          <Progress bar color='secondary' value={getPercentage(pruned)} />
        </Progress>
      </div>
    </SimpleTooltip>
  );
};
